@if (viewSignal(); as view) {
    <div class="card mt-3">
        <div class="card-body">
            <div class="card-title">
                <div class="form-label required">
                    {{ 'event-alarms_Select-vendor-model' | translate }}
                </div>
            </div>

            @if (view.vendorModels.length > 0) {
                <div class="row">
                    <div class="col-6">
                        <div
                            class="d-flex justify-content-between align-items-center border-bottom mb-1">
                            <b>
                                {{ 'event-alarms_available-vendormodels' | translate }}
                                ({{ view.availableVendorModels.length }})
                            </b>

                            <button
                                type="button"
                                class="btn btn-link"
                                (click)="vendorModelsSelected(view.availableVendorModels, true)">
                                {{ 'common_select-all' | translate }}
                            </button>
                        </div>

                        <app-vendor-model-list
                            [vendorModels]="view.availableVendorModels"
                            rowButtonClass="btn-outline-primary"
                            rowButtonIconClass="bi-arrow-right"
                            (removedVendorModel)="vendorModelsSelected([$event], true)" />
                    </div>

                    <div class="col-6">
                        <div
                            class="d-flex justify-content-between align-items-center border-bottom mb-3">
                            <b class="required">
                                {{ 'event-alarms_selected-vendormodels' | translate }}
                                ({{ view.selectedVendorModels.length }})
                            </b>
                            <button
                                type="button"
                                class="btn btn-link"
                                (click)="vendorModelsSelected(view.selectedVendorModels, false)">
                                {{ 'common_removeAll' | translate }}
                            </button>
                        </div>
                        <app-vendor-model-list
                            [vendorModels]="view.selectedVendorModels"
                            (removedVendorModel)="vendorModelsSelected([$event], false)" />
                    </div>
                </div>
            } @else {
                <div class="alert alert-warning text-center" role="alert">
                    {{ 'utilities_nothing_to_select' | translate }}
                </div>
            }

            @if (view.anyUnsupportedEventTypes && !view.allEventTypesUnsupported) {
                <div class="alert alert-warning" role="alert">
                    {{ 'event-alarms_WARNING_UNSUPPORTED_VENDOR_MODEL_SELECTED' | translate }}
                </div>
            }
        </div>
    </div>
}
